module.exports = __webpack_public_path__ + "static/media/f1esport.674de41f.jpg";